import { AssetPack } from "@/game/libs/engine/loader/asset-loader";
import { Aseprite, convertFrametags } from "@/game/libs/engine/sprite/aseprite";
import { Texture, Sprite, Container, Text, TextStyle } from "pixi.js";
import { Player } from "./ecs/components/player";
import Heart from "./ecs/components/heart";
import Yeti from "./ecs/components/yeti";
import Distance from "./ecs/components/distance";
import ObstacleContainer from "./ecs/components/obstacle-container";
var EOTP_Skier = convertFrametags(
  require("@/assets/game/animations/EOTP_Skier.json")
);
var EOTP_playbutton = convertFrametags(
  require("@/assets/game/animations/EOTP_playbutton.json")
);
var EOTP_flag_green = convertFrametags(
  require("@/assets/game/animations/EOTP_flag_green.json")
);
var EOTP_obstacle_flag = convertFrametags(
  require("@/assets/game/animations/EOTP_obstacle_flag.json")
);
var EOTP_yeti = convertFrametags(
  require("@/assets/game/animations/EOTP_yeti.json")
);
var EOTP_logo = convertFrametags(
  require("@/assets/game/animations/EOTP_logo.json")
);

import { Engine } from "@/game/libs/engine/engine";

export function createPlayButton(
  assetpack: AssetPack,
  x: number,
  y: number
): Sprite {
  var spr = new Aseprite(
    assetpack.texture.EOTP_playbutton as Texture,
    EOTP_playbutton
  )
    .centerAnchor()
    .loop("EOTP_playbutton_idle");
  spr.x = x;
  spr.y = y;

  return spr;
}

export function createLogo(assetpack: AssetPack, x: number, y: number): Sprite {
  var spr = new Aseprite(assetpack.texture.EOTP_logo as Texture, EOTP_logo)
    .centerAnchor()
    .loop("EOTP_logo_idle");
  spr.x = x;
  spr.y = y;

  return spr;
}

export function createObstacleFlag(assetpack: AssetPack): Sprite {
  var spr = new Aseprite(
    assetpack.texture.EOTP_obstacle_flag as Texture,
    EOTP_obstacle_flag
  )
    .centerAnchor()
    .loop("EOTP_obstacle_flag_idle");

  return spr;
}

export function createFlag(assetpack: AssetPack, x: number, y: number): Sprite {
  var spr = new Aseprite(
    assetpack.texture.EOTP_flag_green as Texture,
    EOTP_flag_green
  )
    .centerAnchor()
    .loop("EOTP_flag_green_idle");
  spr.x = x;
  spr.y = y;

  return spr;
}

export function createPlayer(
  assetpack: AssetPack,
  shadow: Sprite,
  endGame: (points: number) => void
): Sprite {
  var spr = new Aseprite(assetpack.texture.EOTP_Skier as Texture, EOTP_Skier)
    .centerAnchor()
    .loop("EOTP_skier_face_down_idle");

  var entity = Engine.world.createEntity();

  entity.addComponent(Player, {
    x: 0,
    y: 0,
    lifeCount: 3,
    veloX: 0,
    veloY: 0,
    sprite: spr,
    shadow: shadow,
    endGame: endGame
  });

  return spr;
}

export function createYeti(assetpack: AssetPack, x: number, y: number): Sprite {
  var spr = new Aseprite(assetpack.texture.EOTP_yeti as Texture, EOTP_yeti)
    .centerAnchor()
    .loop("EOTP_yeti_run");
  spr.y = y;

  var entity = Engine.world.createEntity();

  entity.addComponent(Yeti, {
    x: x,
    y: y,
    veloX: 0,
    veloY: 0,
    sprite: spr
  });

  return spr;
}

export function createText(x: number, y: number, str: string): Text {
  var style = new TextStyle();
  style.fill = 0xd73372;
  style.fontSize = "8px";
  style.fontFamily = "Press Start 2P";
  var sprite = new Text(str, style);
  sprite.x = x;
  sprite.y = y;
  var entity = Engine.world.createEntity();

  entity.addComponent(Distance, {
    sprite: sprite
  });

  return sprite;
}

export function createTunein(
  x: number,
  y: number,
  texture: Texture | undefined
): Sprite {
  var sprite = new Sprite(texture);
  sprite.scale.x = 0.38;
  sprite.scale.y = 0.38;
  sprite.x = x;
  sprite.y = y;
  sprite.anchor.x = 0.5;

  return sprite;
}

export function createTopTenButton(
  x: number,
  y: number,
  onclick: () => void,
  tex: Texture
): Sprite {
  var spr = new Sprite(tex);
  spr.x = x;
  spr.y = y;
  spr.interactive = true;
  spr.on("pointerup", onclick);
  return spr;
}

export function createHelpButton(
  x: number,
  y: number,
  onclick: () => void,
  tex: Texture
): Sprite {
  var spr = new Sprite(tex);
  spr.x = x;
  spr.y = y;
  spr.interactive = true;
  spr.on("pointerup", onclick);
  return spr;
}

export function createHeart(
  x: number,
  y: number,
  id: number,
  texOn: Texture,
  texOff: Texture
): Sprite {
  var spr = new Sprite(texOn);
  spr.tint = 0xff0000;
  spr.x = x;
  spr.y = y;
  Engine.world
    .createEntity()
    .addComponent(Heart, { sprite: spr, texOn: texOn, texOff: texOff, id: id });
  return spr;
}

export function createObstacleContainer(spriteContainer: Container) {
  var e = Engine.world.createEntity();
  e.addComponent(ObstacleContainer, {
    container: spriteContainer
  });
}
